exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".model-title[data-v-00cfb974]{border-bottom:1px solid #dfe6ec}.form-box[data-v-00cfb974]{margin-top:20px}.tips[data-v-00cfb974]{margin-top:10px;font-size:14px;color:#999;line-height:1.5}.updata[data-v-00cfb974]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;height:150px}\n", ""]);

// exports
